import React from 'react';
import './PopupPage.css'
import {languageManager} from "../../utils/i18n";
import image_1 from '../../assets/images/popup/1.jpg'
import image_2 from '../../assets/images/popup/2.jpg'
import image_3 from '../../assets/images/popup/3.jpg'
import video_4 from '../../assets/images/popup/4.mp4'
import image_5 from '../../assets/images/popup/5.jpg'
import video_6 from '../../assets/images/popup/6.mp4'
import image_7 from '../../assets/images/popup/7.jpg'
import video_8 from '../../assets/images/popup/8.mp4'
import image_9 from '../../assets/images/popup/9.jpg'
import video_10 from '../../assets/images/popup/10.mp4'
import image_11 from '../../assets/images/popup/11.jpg'

const media = [
	image_1,
	image_2,
	image_3,
	video_4,
	image_5,
	video_6,
	image_7,
	video_8,
	image_9,
	video_10,
	image_11
]

const PopupPage = () => {
	const t = languageManager.t.bind(languageManager);

	return (
		<div className='popup_page'>
			<div className="popup_container ">
				<div className="text_container">
					<h1>{t('popup.title')}</h1>
					<h2>{t('popup.subtitle')}</h2>
					{/*<p>{t('popup.description')}</p>*/}
				</div>
				<div className="image_container ">
					{media.map((item, index) => (
						item.includes('.mp4') ? (
							<video key={index} autoPlay
							       loop
							       muted
							       playsInline>
								<source src={item} type="video/mp4" />
								Your browser does not support the video tag.
							</video>
						) : (
							<img key={index} src={item} alt={`Pop-Up ${index + 1}`} />
						)
					))}
				</div>
			</div>
		</div>
	);
};

export default PopupPage;